module.exports = __webpack_public_path__ + "img/Sistema-Restaurante-Delivery.5d19250c.jpg";